import React from "react"
import {Link} from "react-router-dom"

const TMPButtonLink = (props) => <Link className={"btn btn-primary w-md "+props.extraClassName} {...props}>{props.children}</Link>

export default TMPButtonLink